/**
 * NMS Store Launch · Brand stats
 * Fills the stats (stores = launch store number; states, cities and reviews
 * from the store data) and counts them up once in view.
 */
(() => {
  class NMSSlBrandStats extends window.NMSBaseClass {
    constructor(element, service) {
      super();
      this.element = element;
      this.sl = service;
    }

    init() {
      super.init();
      const totals = this.sl.totals();
      const values = { stores: this.sl.launch.number, states: totals.states, cities: totals.cities, reviews: totals.reviews };
      this.cells = [...this.element.querySelectorAll('[data-stat]')].map(el => {
        const override = el.dataset.override?.replace(/[^\d]/g, '');
        return { el, value: override ? +override : values[el.dataset.stat] || 0, indian: el.dataset.format === 'in', suffix: el.dataset.suffix || '' };
      });

      if (this.sl.reducedMotion) {
        this.#paint(1);
        return;
      }
      this.#paint(0);
      this.io = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        this.io.disconnect();
        const t0 = performance.now();
        const step = now => {
          const t = this.sl.helpers.ease(Math.min(1, (now - t0) / 1400));
          this.#paint(t);
          if (t < 1) this.raf = requestAnimationFrame(step);
        };
        this.raf = requestAnimationFrame(step);
      }, { threshold: .15 });
      this.io.observe(this.element);
    }

    #paint(t) {
      this.cells.forEach(({ el, value, indian, suffix }) => {
        if (!value) {
          el.textContent = '—';
          return;
        }
        const v = Math.round(value * t);
        el.textContent = (indian ? v.toLocaleString('en-IN') : String(v)) + (t >= 1 ? suffix : '');
      });
    }

    destroy() {
      this.io?.disconnect();
      cancelAnimationFrame(this.raf);
      super.destroy();
    }
  }

  const register = () => window.neemans.storeLaunch.register('[data-nms-sl-brand-stats]', NMSSlBrandStats);
  if (window.neemans?.storeLaunch) register();
  else document.addEventListener('nms-sl:ready', register, { once: true });
})();
